import { axiosInstance } from '@/lib/axios';
import { GpsAndBorderCrossingConfigurationModel } from './types';
import { AxiosResponse } from 'axios';

type Props = {
  companyId: string
  payload: GpsAndBorderCrossingConfigurationModel
}

export type UpdateGpsConfigurationResponse = {
  success: boolean
  data?: {
    message?: string
  }
} 

export function updateGpsSettings({ companyId, payload }: Props): Promise<AxiosResponse<UpdateGpsConfigurationResponse>> {
  return axiosInstance.post<UpdateGpsConfigurationResponse>(`/api/${companyId}/configuration/saveGpsConfiguration`, payload);
}
